import { render, staticRenderFns } from "./BaseNacional.vue?vue&type=template&id=7ccba213&"
import script from "./BaseNacional.vue?vue&type=script&lang=js&"
export * from "./BaseNacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports